
export default function NoInfo() {

    return (
        <>
            <div>
                Não há informações disponiveis
            </div>
        </>
    )
}